import { graphql, useStaticQuery } from "gatsby"

export type SiteMetadataLocale = NonNullable<
  NonNullable<NonNullable<Queries.SiteMetadataQuery["site"]>["siteMetadata"]>["locales"]
>[number]

function useSiteMetadata() {
  const data = useStaticQuery<Queries.SiteMetadataQuery>(graphql`
    query SiteMetadata {
      site {
        siteMetadata {
          # siteUrl
          locales {
            slug
            dato
            pim
            label
            labelLocal
            fallbackLocales
          }
          pim {
            baseParams
          }
        }
      }
    }
  `)

  // Return directly wanted data
  return data.site?.siteMetadata ? data.site.siteMetadata : { siteUrl: null, locales: [], pim: null }
}

export default useSiteMetadata
